import React from "react";
import CheckIcon from "../../icons/checkIcon";
import { MENU_SLUG } from "../../constants/constants";
import styles from "./style.module.css";
import { Link } from "react-router-dom";

const Step4 = () => {
  return (
    <div className={`${styles.form_outer} ${styles.successful}`}>
      <div className={styles.form_check}>
        <div className={styles.form_check_icon}>
          <CheckIcon />
        </div>
      </div>
      <div className={styles.form_title}>Successful</div>
      <div className={`${styles.form_subtitle} ${styles.fmb_0}`}>
        Congratulations! Your password has been changed. Click continue to{" "}
        <Link to={`/${MENU_SLUG.login}`}>login</Link>
      </div>
    </div>
  );
};

export default Step4;
